import { MEDIA_LABELS } from "@/data/evidence";

// Media authenticity label — synthetic imagery is never presented as physical evidence.
export const MediaLabel = ({ kinds = [], testId, className = "" }) => (
  <span data-testid={testId || "media-label"} className={`inline-flex flex-wrap gap-1.5 ${className}`}>
    {kinds.map((kind) => (
      <span
        key={kind}
        data-media={kind}
        className="border border-[#F5F5F7]/20 bg-[#030305]/70 px-1.5 py-0.5 font-mono-spec text-[0.52rem] uppercase tracking-[0.2em] text-[#F5F5F7]/75"
      >
        {MEDIA_LABELS[kind] || kind}
      </span>
    ))}
  </span>
);
